import fr from 'facet-rest';
import PicklistRadioGroup from 'Components/UI/Radio/PicklistRadioGroup';
import { isAfterTodayUTC, isBeforeTodayUTC } from 'Helpers/DateTime';

const hiddenFieldNames = [
  'sendEmail',
  'personalizedMessage',
  'bestNextSteps',
  'householdId',
  'sentTime',
  'subject',
  'createdAt',
  'updatedAt',
  'content',
  'startTime',
  'endTime',
  'title',
  'link',
  'calendarEventId',
  'agendas',
  'meetingType',
];

// eslint-disable-next-line import/prefer-default-export
export const MessageTypeOverrides = (meetingResource) => {
  return fr.metaOverride()
    .nameOverride('messageType', {
      _component: () => PicklistRadioGroup,
      _shouldDisableOption: () => (value) => {
        const meetingDate = meetingResource.attr('startTime');
        const isFutureMeeting = isAfterTodayUTC(meetingDate);
        const isPastMeeting = isBeforeTodayUTC(meetingDate);
        if ((value === 'agenda' && isPastMeeting)
          || (value === 'follow-up' && isFutureMeeting)
        ) {
          return true;
        }
        return false;
      },
      _hideLabel: true,
    })
    .nameOverride(name => hiddenFieldNames.includes(name), {
      hidden: true,
    });
};
